import styled, { css } from 'styled-components';
import { withQuery, select } from '@panel/commons/core/themev2';

const ContainerLayout = styled.div`
  max-width: 1480px;
  margin: auto;
  margin-top: 30px;
  display: flex;
  flex-direction: ${({ device }) => (device === 'desktop' ? 'row' : 'column')};
  gap: ${({ device }) => {
    if (device === 'desktop') return '40px';
    if (device === 'tablet') return '32px';
    return '20px';
  }};
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      padding: 16px;
      padding-bottom: 0;
    `}
  ${withQuery.lg.down()} {
    margin-top: ${({ portalWithTelBanner }) => (portalWithTelBanner ? '110' : '80')}px;
  }
`;

const LeftBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  width: 290px;
  position: ${({ device }) => (device === 'desktop' ? 'sticky' : 'unset')};
  top: 40px;
  .separator {
    width: 100%;
    height: 1px;
    background-color: ${select('grayMedium')};
  }
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      width: 100%;
    `}
  @media screen and (max-width: 1530px) {
    margin-left: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
`;

const Main = styled.div`
  width: ${({ device }) => (device === 'desktop' ? '80%' : '100%')};
  margin-bottom: ${({ device }) => (device !== 'desktop' ? 40 : 64)}px;
  overflow: hidden;
  @media screen and (max-width: 1530px) {
    margin-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
  ${withQuery.xl.down()} {
    width: ${({ device }) => (device === 'desktop' ? '75%' : '100%')};
  }
  @media screen and (max-width: 1330px) {
    padding-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      width: 100%;
    `}
`;

const LoaderWrapper = styled.div`
  background-color: rgb(256, 256, 256, 0.6);
  width: 100vw;
  height: 100vh;
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { ContainerLayout, LeftBar, Main, LoaderWrapper };
